import { useState } from 'react';
import * as M from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useParams, useSearchParams } from 'react-router-dom';

import { useGetAiAgentTemplates } from '../../../../../../shared/apis/ai-agent/template/reactQueries';
import * as C from '../../../../../ui/common/CommonStyles';
import AiAgentTabs from '../../Common/ui/AiAgentTabs';
import useAiAgentTemplateFilters from './hooks/useAiAgentTemplateFilters';
import AiAgentAsTemplateFilterSection from './ui/filterSection';
import TemplateDetailModal from './ui/templateDetailModal';
import TemplateListTable from './ui/templateListTable';

export default function AiAgentTemplate() {
  const { companyId } = useParams();
  const [searchParams] = useSearchParams();
  const companyName = searchParams.get('companyName') || '';
  const [opened, { open, close }] = useDisclosure(false);
  const [selectedTemplate, setSelectedTemplate] = useState<{ templateId: number; headerIndex: number } | null>(null);
  const { filterForm, queryParams, updateFilterForm, applyFilters, resetFilters } = useAiAgentTemplateFilters(Number(companyId));
  const onOpenTemplateDetailModal = (templateId: number, headerIndex: number) => {
    setSelectedTemplate({ templateId, headerIndex });
    open();
  };

  const { data } = useGetAiAgentTemplates(queryParams);

  return (
    <div>
      {/* <C.TitleBox>
        <div className="title">AS/CS 템플릿 관리</div>
      </C.TitleBox> */}
      <C.ListBox>
        <M.Stack gap="lg">
          <M.Flex
            gap="md"
            align="center"
            justify="space-between"
            style={(theme) => ({
              border: `1px solid ${theme.colors.gray[3]}`,
              backgroundColor: theme.colors.gray[0],
              borderRadius: theme.radius.sm,
              padding: theme.spacing.sm,
            })}
          >
            <M.Box>
              <M.Text size="xs" c="gray.6">
                거래처명
              </M.Text>
              <M.Text fw={500}>{companyName}</M.Text>
            </M.Box>
          </M.Flex>
          <AiAgentTabs />
          <AiAgentAsTemplateFilterSection
            filterForm={filterForm}
            onChangeFilterForm={updateFilterForm}
            onSearch={applyFilters}
            onReset={resetFilters}
          />
          <TemplateListTable onOpen={onOpenTemplateDetailModal} data={data} />
          {opened && (
            <TemplateDetailModal
              opened={opened}
              onClose={close}
              templateId={selectedTemplate?.templateId || 0}
              headerIndex={selectedTemplate?.headerIndex || 0}
            />
          )}
        </M.Stack>
      </C.ListBox>
    </div>
  );
}
